import React, { useEffect, useState, useCallback } from 'react';
import './Footer.css';
import LogoLight from "../../asset/logo_light.png";
import LogoDark from "../../asset/logo_dark.png";
import EULogo from "../../asset/eu-logo.png";

const translations = {
    english: {
      language: 'Language',
      confessDataToolMenu: 'Confess-data-tool-Menu',
      home: 'Home',
      dashboard: 'Dashboard',
      dataPolicy: 'Data Policy',
      imprint: 'Imprint',
      logout: 'Logout',
    },
    german: {
      language: 'Sprache',
      confessDataToolMenu: 'Confess-Daten-Tool-Menü',
      home: 'Startseite',
      dashboard: 'Dashboard',
      dataPolicy: 'Datenschutzerklärung',
      imprint: 'Impressum',
      logout: 'Abmelden',
    },
    czech: {
      language: 'Jazyk',
      confessDataToolMenu: 'Konfesní datové nástroje - Menu',
      home: 'Domů',
      dashboard: 'Dashboard',
      dataPolicy: 'Zásady ochrany osobních údajů',
      imprint: 'Otisk',
      logout: 'Odhlásit se',
    },
    italian: {
      language: 'Lingua',
      confessDataToolMenu: 'Confess-data-tool-Menu',
      home: 'Home',
      dashboard: 'Dashboard',
      dataPolicy: 'Informativa sulla privacy',
      imprint: 'Note legali',
      logout: 'Esci',
    },
  };


function Footer() {
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
  return (
        <footer className="footer">
            <div className="logo-container">
                <div className="logo-info-confess">
                    <img src={LogoDark} alt="logo" width={250} background={'black'}/>
                    <p>Developed by <a href="https://www.confess-life.eu/" target="_blank">confess-life.eu</a></p>
                </div>
                <div className="logo-info">
                    <img src={EULogo} alt="logo" width={150} />
                    <p><i>Co-funded by the European Union. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union or CINEA. Neither the European Union nor the granting authority can be held responsible for them.</i></p>
                </div>
            </div>                           

            <div className="footer-bottom">
                <p>© 2024 INaB, RWTH Aachen. All rights reserved.</p>
                <div>
                    <a href="/datapolicy">{translations[currentLanguage].dataPolicy}</a>   
                </div>
                <div>           
                    <a href="/imprint">{translations[currentLanguage].imprint}</a>
                </div>
            </div>
        </footer>
  );
}

export default Footer;
